import './index.less';
import React from 'react';
import { Popover } from 'antd';
import ReactSwipe from 'react-swipe';

const swipeOptions = {
  startSlide: 0,
  auto: 0,
  speed: 300,
  disableScroll: true,
  continuous: true,
};

class Swiper extends React.Component {

  constructor(props) {
    super(props);
  
    this.state = {
      player: false
    };
  }

  next = () => {
    this.reactSwipe.next();
  }

  prev = () => {
    this.reactSwipe.prev();
  }

  paneNodes = () => {
    const dom = [];
    const { teacherList } = this.props;
    for (let i = 0; i < teacherList.length; i += 1) {
      dom.push(<div key={i} className='teacherList-swiperItem'>{this.renderTeacher(teacherList[i])}</div>);
    }
    return dom;
  }

  play = (i) => {
    this.setState({
      player: i
    })
  }

  selectTec = (tec) => {
    const { selectTec } = this.props;
    selectTec(tec);
  }

  renderTeacher = (data) => {
    const dom = [];
    const { player } = this.state;
    const { teacher } = this.props;
    for (let i = 0; i < data.length; i += 1){
      dom.push(
        <div key={i} className='teacherList-teacher'>
          {
            player === data[i].id ? (
              <div className='teacherList-avatar'>
                <video id='media' ref='media' className='teacherList-video' controls='false' type='video/mp4' src={data[i].teacher.video_path} webkit-playsinline='true' playsInline='false' autoPlay='autoplay'></video>
              </div>
            ):
            (
              <div className='teacherList-avatar'>
                <img src={data[i].avatar} alt=''/>
                <img onClick={() => this.play(data[i].id)} className='teacherList-player' src='https://static.cleanlive.cn/user-center/images/play.png' alt=''/>
              </div>
            )
          }
          <div className={ teacher.id === data[i].id ? 'teacherList-tecInfo teacherList-select' : 'teacherList-tecInfo'}>
            <p className='teacherList-name'>{data[i].name}</p>
            {
              data[i].teacher.intro ? 
              (<Popover placement='bottomLeft' content={<p style={{width: '300px'}} dangerouslySetInnerHTML={{ __html:data[i].teacher.intro}}></p>} trigger='hover'>
                <p className='teacherList-introduce teacherList-textOverflow2' dangerouslySetInnerHTML={{ __html:data[i].teacher.intro}}></p>
              </Popover>):
              <p className='teacherList-introduce'>该老师暂时没有介绍。</p>
            }
            <div className={ teacher.id === data[i].id ? 'teacherList-btn teacherList-select' : 'teacherList-btn'} onClick={() => this.selectTec(data[i])}></div>
          </div>
        </div>
      )
    }
    return dom;
  }

  render() {
    const { teacherList } = this.props;
    if (!teacherList.length) return null
    return (
      <div className="slide">
        <ReactSwipe ref={reactSwipe => this.reactSwipe = reactSwipe} className="mySwipe" swipeOptions={swipeOptions}>
            {
              this.paneNodes()
            }
        </ReactSwipe>
      </div>
    );
  }
}

export default Swiper;



// WEBPACK FOOTER //
// ./src/components/swiper/swiper.jsx